import React from 'react';

// Create app-wide shared context (needs to be in a separate file for 'this.context' to work)
export default React.createContext({});
